module.exports = __webpack_public_path__ + "static/media/dayend.28702ee3.png";